import type { App } from 'vue'
import AppTable from '@/components/table/AppTable/AppTable.vue'
import FormElement from '@/components/common/FormElement/FormElement.vue'
import NotifyComponent from '@/components/common/NotifyComponent/NotifyComponent.vue'
import PaginationComponent from '@/components/common/PaginationComponent/PaginationComponent.vue'
import SvgIcon from '@/components/ui/SvgIcon/SvgIcon.vue'
import AddBtn from '@/components/ui/AddBtn/AddBtn.vue'
import AppLoader from '@/components/ui/AppLoader/AppLoader.vue'
import AppPopup from '@/components/ui/AppPopup/AppPopup.vue'
import CheckboxRadioElement from '@/components/ui/CheckboxRadioElement/CheckboxRadioElement.vue'
import ConfirmPopup from '@/components/ui/ConfirmPopup/ConfirmPopup.vue'
import DeleteIconBtn from '@/components/ui/DeleteIconBtn/DeleteIconBtn.vue'
import DeleteTextBtn from '@/components/ui/DeleteTextBtn/DeleteTextBtn.vue'
import EditBtn from '@/components/ui/EditBtn/EditBtn.vue'
import EditIconBtn from '@/components/ui/EditIconBtn/EditIconBtn.vue'
import FormActionBtns from '@/components/ui/FormActionBtns/FormActionBtns.vue'
import MultiselectElement from '@/components/ui/MultiselectElement/MultiselectElement.vue'
import SelectElement from '@/components/ui/SelectElement/SelectElement.vue'
import TabsNav from '@/components/ui/TabsNav/TabsNav.vue'
import ToggleElement from '@/components/ui/ToggleElement/ToggleElement.vue'
import TooltipComponent from '@/components/ui/TooltipComponent/TooltipComponent.vue'
import ContextMenu from '@/components/common/ContextMenu/ContextMenu.vue'

const globalComponents = (app: App) => {
  app.component('SvgIcon', SvgIcon)
  app.component('NotifyComponent', NotifyComponent)
  app.component('FormElement', FormElement)
  app.component('FormActionBtns', FormActionBtns)
  app.component('EditBtn', EditBtn)
  app.component('EditIconBtn', EditIconBtn)
  app.component('AddBtn', AddBtn)
  app.component('AppLoader', AppLoader)
  app.component('SelectElement', SelectElement)
  app.component('CheckboxRadioElement', CheckboxRadioElement)
  app.component('ToggleElement', ToggleElement)
  app.component('TabsNav', TabsNav)
  app.component('AppTable', AppTable)
  app.component('DeleteIconBtn', DeleteIconBtn)
  app.component('TooltipComponent', TooltipComponent)
  app.component('AppPopup', AppPopup)
  app.component('ConfirmPopup', ConfirmPopup)
  app.component('DeleteTextBtn', DeleteTextBtn)
  app.component('PaginationComponent', PaginationComponent)
  app.component('MultiselectElement', MultiselectElement)
  app.component('ContextMenu', ContextMenu)
}

export default globalComponents
